import React from "react";
import Navbar from "../Navbar/Navbar";
import { Link } from "react-router-dom";

const values = [
  {
    title: "Integrity",
    description:
      "We build honest products. No inflated metrics, no empty promises, just software that works and a team you can trust.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
  },
  {
    title: "Craftsmanship",
    description:
      "Every line of code matters. We obsess over details because we know that great software is built through discipline and care.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11.42 15.17l-5.1-5.1m0 0L11.42 4.97m-5.1 5.1h13.31" />
      </svg>
    ),
  },
  {
    title: "Impact",
    description:
      "We measure success by the real-world outcomes our products create for our clients, their customers, and the communities they serve.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
      </svg>
    ),
  },
  {
    title: "Collaboration",
    description:
      "We work alongside our clients, not just for them. The best products come from shared understanding and open communication.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
      </svg>
    ),
  },
];

export default function HeroAbout() {
  return (
    <>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 bg-white overflow-hidden">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-blue-50 rounded-full blur-3xl opacity-50" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-16">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-full mb-8 border border-blue-100">
              <div className="w-1.5 h-1.5 rounded-full bg-[#0186ef]" />
              <span className="text-xs font-semibold text-[#0186ef] uppercase tracking-wider">
                About Us
              </span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 leading-[1.1] tracking-tight mb-6">
              We build software that{" "}
              <span className="text-[#0186ef]">solves real problems</span>
            </h1>

            <p className="text-lg text-gray-500 leading-relaxed max-w-2xl">
              DevDesk Integrated Services is a Nigerian software company focused
              on creating practical, well-crafted digital products. Our flagship
              product, Devdesk Pool, powers pool betting operations for
              businesses across Africa. We believe in building software that works, not just in theory, but in the real world where it matters most.
            
            </p>
          </div>
        </div>
      </section>

      {/* Story */}
      <section className="py-24 lg:py-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our story</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  DevDesk was founded with a clear purpose: to close the gap
                  between emerging businesses in Nigeria and the technology they
                  need to compete globally. We saw first-hand how fragmented and
                  unreliable software solutions were holding companies back.
                </p>
                <p>
                  So we set out to build better. Our approach is simple: listen
                  to the real problems our clients face, then engineer solutions
                  that actually work in the field. That thinking led us to create{" "}
                  <strong>Devdesk Pool</strong>, a SaaS platform that handles the
                  full complexity of pool betting across POS terminals, Android,
                  iOS, and the web.
                </p>
               
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2940&auto=format&fit=crop"
                alt="Team collaboration"
                className="rounded-3xl w-full object-cover aspect-[4/3]"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-5 border border-gray-100">
                <div className="text-sm font-semibold text-gray-900">
                  Built in Nigeria
                </div>
                <div className="text-xs text-gray-500 mt-0.5">
                  Serving clients nationwide
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-16">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              What drives us
            </h2>
            <p className="text-lg text-gray-500 max-w-xl mx-auto">
              These aren't slogans on a wall. They're the principles we apply to
              every product we ship.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {values.map((value, i) => (
              <div
                key={i}
                className="p-8 rounded-2xl bg-gray-50 border border-gray-100 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#0186ef]/10 text-[#0186ef] flex items-center justify-center mb-5">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-500 leading-relaxed text-sm">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 lg:py-32 bg-gray-900">
        <div className="max-w-4xl mx-auto px-6 lg:px-16 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Have a project in mind?
          </h2>
          <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto">
            We'd love to learn about what you're building and explore how we can
            help.
          </p>
          <Link
            to="/contact"
            className="inline-flex px-8 py-4 text-sm font-semibold text-gray-900 bg-white rounded-full hover:bg-gray-100 transition-all duration-300 hover:shadow-lg"
          >
            Get in Touch
          </Link>
        </div>
      </section>
    </>
  );
}
